<script>
import Layout from "@layouts/form";
import TarefaStatus from "@forms/TarefaStatus";

export default {
  page: {
    title: "Detalhes | Status da tarefa"
  },
  components: { Layout, TarefaStatus },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Status da Tarefa",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Status da Tarefa",
          href: "/TarefaStatus"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <TarefaStatus :editable="editable"></TarefaStatus>
    </div>
  </Layout>
</template>
